module.exports = __webpack_public_path__ + "static/media/05_CALCINHA_TRADICIONAL_EMPINA_BUMBUM_LISA_02.0c51878c.jpg";